var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',_vm._b({staticClass:"button--blue-shadow",class:{ 'button--disabled' : !_vm.isActive },on:{"click":_vm.changePage}},'span',{ 'disabled' : !_vm.isActive },false),[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }